import { createFileRoute } from '@tanstack/react-router';

import DeviceRegistration from '@/ui/pages/DeviceRegistration/DeviceRegistration';

export interface DeviceRegistrationSearch {
  readonly sessionId?: string | undefined;
  readonly institutionId?: string | undefined;
  /** @deprecated Legacy spelling of `institutionId`; see utils/activationSearch.ts. */
  readonly tenantId?: string | undefined;
  /** The kiosk's own id, forwarded to `POST /DeviceRegistration/request` so it keeps its identity. */
  readonly deviceId?: string | undefined;
}

// Public route (no auth guard): a device deep-links here as
// /device-registration?sessionId=…&institutionId=…&deviceId=… to register itself against a lab.
// `tenantId` is the legacy spelling of the same value and stays accepted while devices roll over.
export const Route = createFileRoute('/device-registration')({
  validateSearch: (search: Record<string, unknown>): DeviceRegistrationSearch => ({
    sessionId: typeof search.sessionId === 'string' ? search.sessionId : undefined,
    institutionId: typeof search.institutionId === 'string' ? search.institutionId : undefined,
    tenantId: typeof search.tenantId === 'string' ? search.tenantId : undefined,
    deviceId: typeof search.deviceId === 'string' ? search.deviceId : undefined,
  }),
  component: DeviceRegistration,
});
